import NavItem from "./NavItem";
import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Api from "../../Api/Api.json";

const SidebarContent = ({
  items,
  isActiveRoute,
  onItemClick,
  className = "",
}) => {
  const auth = useAuth();
  const navigate = useNavigate();
  const logoutRedirectUri =
    process.env.NODE_ENV === "production"
      ? "https://upskill.semionbd.com"
      : "http://localhost:3000";

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (auth.isAuthenticated && localStorage.getItem("upskill_user_info") === null) {
        localStorage.setItem("auth_user", JSON.stringify(auth.user));
        const id_token = auth.user.id_token;
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${id_token}`,
        };
        const base_url = Api.UPSKILL_AUTH;
        const body = {
          task: "getUserInfo",
        };

        try {
          const response = await axios.post(base_url, body, { headers });
          localStorage.setItem(
            "upskill_user_info",
            JSON.stringify(response.data[0])
          );
          console.log("User id:", response.data[0].id);
        } catch (err) {
          console.error("Error fetching user info:", err);
        }
      }
    };

    fetchUserInfo();
  }, [auth.isAuthenticated]);

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }

  const signOutRedirect = () => {
    localStorage.removeItem("auth_user");
    localStorage.removeItem("upskill_user_info");
    auth.removeUser();
    const clientId = "4epirtvput7o9c2coeevkrocqs";
    const logoutUri = logoutRedirectUri;
    const cognitoDomain =
      "https://us-east-1r9k6yg3ln.auth.us-east-1.amazoncognito.com";
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
      logoutUri
    )}`;
  };
  return (
    <div
      className={`flex-1 overflow-y-auto py-4 px-4 ${className}`}
      style={{ maxHeight: "calc(100vh - 80px)" }}
    >
      <nav className="space-y-2">
        {items.map((item) => (
          <NavItem
            key={item.id}
            item={item}
            isActive={isActiveRoute(item.path)}
            onClick={onItemClick}
          />
        ))}
        <div className="mt-4">
          {auth.isAuthenticated ? (
            <button
              onClick={signOutRedirect}
              className="w-full flex items-center space-x-4 p-4 rounded-xl bg-red-100 text-red-700 hover:bg-red-200 transition-colors duration-200"
            >
              <span className="font-medium">লগ আউট</span>
            </button>
          ) : (
            <button
              onClick={() => auth.signinRedirect()}
              className="w-full flex items-center space-x-4 p-4 rounded-xl bg-blue-100 text-blue-700 hover:bg-blue-200 transition-colors duration-200"
            >
              <span className="font-medium">লগইন</span>
            </button>
          )}
        </div>
      </nav>
    </div>
  );
};

export default SidebarContent;
